import * as React from 'react'
import dayjs from 'dayjs'
import { Select } from 'antd'
import { LogCategory } from '@lmc/ts-common'
import { useTranslation } from 'react-i18next'
import { RangePicker } from '@lmc/ui-kit'

type CareDeliverFilterProps = {
  categories: LogCategory[]
  setCategoryId: (a: string) => void
  to: dayjs.Dayjs
  from: dayjs.Dayjs
  setToDate: (d: dayjs.Dayjs) => void
  setFromDate: (d: dayjs.Dayjs) => void
}

type Values = [dayjs.Dayjs, dayjs.Dayjs]

export const CareDeliveryFilters = ({
  categories,
  setCategoryId,
  to,
  from,
  setToDate,
  setFromDate,
}: CareDeliverFilterProps): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <div style={styles.container}>
      {/* @ts-ignore */}
      <RangePicker
        ranges={{
          [t('general.filters.dateRanges.lastWeek')]: [
            dayjs().subtract(1, 'week'),
            dayjs(),
          ],
          [t('general.filters.dateRanges.lastMonth')]: [
            dayjs().subtract(1, 'month'),
            dayjs(),
          ],
          [t('general.filters.dateRanges.lastThreeMonths')]: [
            dayjs().subtract(3, 'month'),
            dayjs(),
          ],
          [t('general.filters.dateRanges.lastYear')]: [
            dayjs().subtract(1, 'year'),
            dayjs(),
          ],
        }}
        format="DD-MM-YYYY"
        defaultValue={[from, to]}
        // @ts-ignore
        onChange={(values: Values) => {
          setFromDate(dayjs(values[0]))
          setToDate(dayjs(values[1]))
        }}
        disabledDate={(date) => date.isAfter(dayjs())}
      />
      <Select
        defaultValue={null}
        style={styles.select}
        onChange={(val: string) => {
          setCategoryId(val)
        }}
        options={[
          {
            value: null,
            label: t('reports.careDelivery.allCategoriesFilter'),
          },
          ...categories
            .filter((cat) => cat.itemId !== 'bodyMaps')
            .map((cat) => ({
              value: cat.id,
              label: cat.name,
            })),
        ]}
      />
    </div>
  )
}

const styles = {
  container: { padding: '12px 0 24px 0' },
  select: { paddingLeft: 18, width: 180 },
}

export default CareDeliveryFilters
